import styled from 'styled-components';

const Button = styled.button`
  width: 18px;
  border: none;
  background-color: #FFF;
`;

export default Button;
